
import React, { useEffect, useState } from 'react';
import ConnUrls from '../../Connections/ConnectURL';
import PopUpOneLine from '../PopUpOneLine';



const Crdit_Token_Problem = (props) => {

    return (
        <PopUpOneLine
            cssStyl={"specialPopComp onTopOfAll noPadding"}
            key={"popCreditTokenProblem"}
            topTitle={"בעיית חיוב"}
            Title={[
                "התגלתה בעייה בחיוב בכרטיס הקיים",
                "ניתן להמשיך עם ההזמנה",
                "ולבצע תשלום בכרטיס אחר או במזומן"
            ]}
            inLabel={""}
            closeFunc={() => props.closePop()}
            btn1Clck={() => props.closePop()}
            btn1Txt={"סגור"}
            btn2Txt={"אשלם בצורה אחרת"}
            btn2Clck={() => {
                props.okClick();
            }}
        />
    )
}


export default Crdit_Token_Problem